import { useEffect } from "react";
import { useLanguage } from "./LanguageContext.tsx";

/**
 * Mounts once at the app root (inside LanguageProvider).
 * Owns all language side effects: URL sync, localStorage, popstate.
 * Renders nothing.
 */
const LanguageSyncAdapter: React.FC = () => {
  const { currentLang, setLanguage } = useLanguage();

  // Sync localStorage, document lang, and URL whenever language changes
  useEffect(() => {
    localStorage.setItem("language", currentLang);
    document.documentElement.lang = currentLang;

    const newPath = currentLang === "zh" ? "/zh" : "/";
    window.history.pushState({}, "", newPath + window.location.hash);
  }, [currentLang]);

  // Sync language state back from browser back/forward navigation
  useEffect(() => {
    const handlePopState = () => {
      const lang = window.location.pathname.startsWith("/zh") ? "zh" : "en";
      setLanguage(lang);
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [setLanguage]);

  return null;
};

export default LanguageSyncAdapter;
